// Interface copy in English — every other language file must translate each key.
// Logos, wordmarks and legal pages are never translated.
export const en = {
  'lang.label': 'Language',

  'nav.residences': 'Residences',
  'nav.mobility': 'Mobility',
  'nav.retreats': 'Retreats',
  'nav.slClub': 'SL Club',
  'nav.privateLine': 'Private Line',
  'nav.membership': 'Membership',
  'nav.login': 'Login',
  'nav.menu': 'Menu',
  'nav.closeMenu': 'Close menu',
  'nav.home': 'Superluxury — home',

  'menu.clientLine': 'Client Line',
  'menu.clientLineNote': 'Answered by a partner, at any hour.',

  'announcement.text': 'Private consultations are now received in our new Geneva and Dubai ateliers.',
  'announcement.link': 'Request a private audience',
  'announcement.close': 'Close announcement',

  'hero.label': 'Introducing Superluxury',
  'hero.srTitle': 'Venturist — a private event series by Superluxury',
  'hero.tagline': 'A private series by Superluxury. By invitation only.',
  'hero.discover': 'Discover Venturist',
  'hero.scroll': 'Scroll to discover',
  'hero.pause': 'Pause film',
  'hero.play': 'Play film',

  'footer.help': 'May We Help You?',
  'footer.faq': 'Frequently Asked Questions',
  'footer.support': 'Support: English',
  'footer.house': 'The House',
  'footer.locator': 'Atelier Locator',
  'footer.locatorPlaceholder': 'COUNTRY/REGION, CITY',
  'footer.findAtelier': 'Find an atelier',
  'footer.lettersTitle': 'Sign Up for Superluxury Letters',
  'footer.lettersBody':
    'Receive exclusive notes on new services, personal invitations and further news from the world of Superluxury.',
  'footer.lettersThanks': 'Thank you. You will receive the next letter.',
  'footer.email': 'Email',
  'footer.signUp': 'Sign up',
  'footer.emailError': 'Please enter a valid email address.',
  'footer.country': 'Country/Region',
  'footer.services': 'Superluxury Services',
  'footer.discoverServices': 'Discover Our Services',
  'footer.seekIntro': 'Seek an Introduction',
  'footer.destinations': 'Destinations',
  'footer.follow': 'Follow Us',
  'footer.rights': 'All rights reserved.',
};

export type UiKey = keyof typeof en;
